"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwPodRow = _interopRequireDefault(require("./CwPodRow.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var CwPodRow = function CwPodRow(props) {
  return _react.default.createElement("div", {
    style: props.style,
    className: (0, _classnames.default)(_CwPodRow.default.podRow, props.className)
  }, props.children);
};

CwPodRow.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]),

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object,

  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string
};
var _default = CwPodRow;
exports.default = _default;